import { connect } from 'react-redux';
import get from 'lodash/get';
import Scores from './Fixture';
import { actions as Page } from '@pages/names';

import { matchesByDate, bracketMatchesByDate } from '@selectors/matches';

export const mapStateToProps = (state) => {
  if (!state.matches || state.matches.length === 0) {
    return { isReady: false };
  }
  const isEmbed = get(state, 'location.type') === Page.FixtureEmbed;
  // embed only must show bracket matches
  const byDate = isEmbed ? bracketMatchesByDate(state) : matchesByDate(state);
  const matches = Object.keys(byDate)
    .sort()
    .map((date) => [date, byDate[date]]);
  return {
    isReady: true,
    matchesByDate: matches,
    now: get(state, 'now'),
    isEmbed,
  };
};

export default connect(mapStateToProps)(Scores);
